import { StatusPage } from "./StatusPage";

/**
 * Rendered by main.tsx instead of the app when configuration is invalid (WEB-009).
 * Problems are shown in development; in production they go to the console for operators,
 * and users see only what to do.
 */
export function ConfigErrorPage({ problems }: { problems: readonly string[] }) {
  return (
    <StatusPage
      code="Configuration error"
      title="ThyroAID isn't set up correctly"
      {...(import.meta.env.DEV ? { details: problems.join("\n") } : {})}
    >
      <p>
        This installation is missing required settings, so it can't connect safely. Contact your
        ThyroAID administrator. No data was sent.
      </p>
    </StatusPage>
  );
}
